import smoothscroll from 'smoothscroll-polyfill';
import { EnvironmentConfig, initStore, PrivacyService, setupConfig, setupStyles, TrackingService } from '@recruiting-solutions/rs-shared';
import { searchUI } from '@recruiting-solutions/search-ui-shared';
import { Env } from '@stencil/core';
import { getCountryCodes } from './arv-helper';
import { arvGmtTrackingService } from './tracking/arv-gtm-tracking.service';
import { candidateUI, ICandidateStore, StorageType, UtmService } from '@recruiting-solutions/candidate-ui-shared';

smoothscroll.polyfill();

export const prodConfig: EnvironmentConfig = {
    tenantId: 'arvProd-87zb9',
    customerTag: 'arv',
    production: true,
    version: Env.version,
    hostingUrl: 'https://csbep-arv-prod.firebaseapp.com',
    storageUrl: 'https://cdn.recruiting-solutions.org/arv-prod',
    customerId: 'arv-prod',
    functionsUrl: 'https://europe-west1-csbep-75ff0.cloudfunctions.net',
    indexName: 'arv-prod',
    googleApiKey: 'AIzaSyCGtNvnLPWxJ8s4hxlDsHtb8uADLENNvRA', // Check if the key is correct
    oneDriveRedirectUrl: 'https://jobsearch.createyourowncareer.com/RTL/content/redirect/',
    oneDriveClientId: '5b3a88f5-6c1c-4d0f-beac-c8e243836841',
    googleDriveClientId: '810652930634-jum0hq23djd876ui2btd21vodke1994k.apps.googleusercontent.com',
    googleDriveAppId: '810652930634',
    dropBoxAppKey: 'xpsiw1ve6pwg24e',
    microsoftClientId: '3825a6f3-24cb-47d4-8aa2-35d3e5891324',
    indexUrl: 'https://searchui.search.windows.net/',
    indexApiKey: '6BBD74F1CBD41E5B0232FB05C5B78ED9',
    suggestFields: 'title',
    searchFields: ['jobId', 'title', 'description', 'location/city'],
    facets: [
        { name: 'jobFamily', isList: false },
        { name: 'jobFamilyId', isList: false },
        { name: 'jobWorld', isList: false },
        { name: 'jobWorldId', isList: false },
        { name: 'employmentType', isList: false },
        { name: 'employmentTypeId', isList: false },
        { name: 'careerLevel', isList: false },
        { name: 'careerLevelId', isList: false },
        { name: 'teleComuteId', isList: false },
        { name: 'location/countryCity', isList: false },
        { name: 'location/postingCountry', isList: false },
        { name: 'location/countryCode', isList: false },
    ],
    getServerBrand: false,
    idContainsLang: true,
    isDebug: false,
    isFirebaseLocal: false,
};

initStore<ICandidateStore>({
    isLoggedIn: false,
    user: undefined,
    newUser: false,
    loading: false,
    loadingId: 'default',
    isAnon: true,
    email: undefined,
    error: undefined,
    errorId: undefined,
    job: undefined,
    applicationFormData: {},
    questionsFormData: undefined,
    questions: undefined,
    credentialAlreadyInUse: false,
    currentStep: undefined,
    nextButton: undefined,
    previousButton: undefined,
    pickListData: undefined,
    hideLoading: false,
    filesToDelete: [],
});
setupConfig(prodConfig);

setupStyles();

candidateUI.init('Production', StorageType.BrowserWindow, false);

searchUI.init('Production', false, {
    useLanguageFilter: true,
    getCountryCodes: getCountryCodes,
    brandFilters: [
        { key: 'Arvato_SCM', value: 'Arvato_SCM' },
        { key: 'ARVATO', value: 'ARVATO' },
    ],
});

PrivacyService.init();
TrackingService.init([arvGmtTrackingService]);
const url = new URL(window.location.href);

if (
    window.document.referrer &&
    window.document.referrer.indexOf('createyourowncareer') === -1 &&
    window.document.referrer.indexOf('.valhalla.') === -1 &&
    window.document.referrer.indexOf('localhost') === -1 &&
    window.document.referrer.indexOf('recruiting-solutions.org') === -1 &&
    !url.searchParams.has('utm_referrer') &&
    !sessionStorage.getItem('csb-bert-referrer')
) {
    sessionStorage.setItem('csb-bert-referrer', window.document.referrer);
}

UtmService.persistParameters();
UtmService.restoreParameters();

export default async () => {
    /**
     * The code to be executed should be placed within a default function that is
     * exported by the global script. Ensure all of the code in the global script
     * is wrapped in the function() that is exported.
     */
};
